// Méta-données partagées du cockpit « Pilotage des opérations — Équipe ».
// Tokens de couleur alignés sur l'identité Baobab Connect (vert #1db584).

export const STATUS_META = {
  demande_enregistree: { label: 'Demande enregistrée', tone: 'slate' },
  devis_accepte: { label: 'Devis accepté', tone: 'slate' },
  planifiee: { label: 'Planifiée', tone: 'blue' },
  prete_au_chargement: { label: 'Prête au chargement', tone: 'blue' },
  en_cours_de_chargement: { label: 'En chargement', tone: 'blue' },
  charge_en_route: { label: 'En route', tone: 'indigo' },
  en_cours_de_dechargement: { label: 'En déchargement', tone: 'indigo' },
  en_attente_paiement: { label: 'En attente paiement', tone: 'amber' },
  livree: { label: 'Livrée', tone: 'emerald' },
  terminee: { label: 'Terminée', tone: 'emerald' },
};

// Classes pour la barre de progression (Répartition par statut)
export const TONE_BAR = {
  slate: 'bg-slate-400',
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  amber: 'bg-amber-500',
  emerald: 'bg-emerald-500',
  red: 'bg-red-500',
};

// Classes pour un badge de statut
export const TONE_BADGE = {
  slate: 'bg-slate-50 text-slate-600 ring-slate-200',
  blue: 'bg-blue-50 text-blue-700 ring-blue-200',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-200',
  amber: 'bg-amber-50 text-amber-700 ring-amber-200',
  emerald: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
};

export const statusMeta = (status) =>
  STATUS_META[status] || { label: status || '—', tone: 'slate' };

// Priorité / SLA
export const PRIORITY_META = {
  urgent: { label: 'Urgent', cls: 'bg-red-50 text-red-700 ring-red-200' },
  haut: { label: 'Haut', cls: 'bg-orange-50 text-orange-700 ring-orange-200' },
  normal: { label: 'Normal', cls: 'bg-blue-50 text-blue-700 ring-blue-200' },
  faible: { label: 'Faible', cls: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
};

// Disponibilité opérateur
export const AVAILABILITY_META = {
  disponible: { label: 'Disponible', cls: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
  elevee: { label: 'Élevée', cls: 'bg-amber-50 text-amber-700 ring-amber-200' },
  surcharge: { label: 'Surchargé', cls: 'bg-red-50 text-red-700 ring-red-200' },
};

export const roleLabel = (role) =>
  ({ ops: 'Ops', field_ops: 'Field', lead_field_ops: 'Lead Field', lead_ops: 'Lead Ops' }[role] || 'Ops');

export const initials = (name = '') =>
  name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '—';

// Palette d'avatars déterministe à partir d'une chaîne
const AVATAR_COLORS = [
  'bg-emerald-500', 'bg-blue-500', 'bg-indigo-500', 'bg-rose-500',
  'bg-amber-500', 'bg-teal-500', 'bg-violet-500', 'bg-cyan-600',
];
export const avatarColor = (key = '') => {
  let h = 0;
  for (let i = 0; i < key.length; i += 1) h = (h * 31 + key.charCodeAt(i)) % AVATAR_COLORS.length;
  return AVATAR_COLORS[Math.abs(h)] || AVATAR_COLORS[0];
};

export const fmtNum = (n) => (n ?? 0).toLocaleString('fr-FR');

export const fmtDate = (val) => {
  if (!val) return '—';
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '—';
  }
};

export const QUEUE_TABS = [
  { key: 'all', label: 'Toutes' },
  { key: 'unassigned', label: 'À assigner' },
  { key: 'late', label: 'En retard' },
  { key: 'to_load', label: 'À charger' },
  { key: 'en_route', label: 'En route' },
  { key: 'delivered', label: 'Livrées' },
];
